import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const TransactionsWidgetSkeleton = () => (
  <div className='box-border w-full h-[320px] rounded-[12px] flex px-[24px] py-[30px] flex-col'>
    <SkeletonTheme baseColor='#DFE2EB'>
      <div className='h-[11px] leading-3'>
        <Skeleton width='156px' height='11px' borderRadius='13px' count={1} />
      </div>
      <div className='h-[11px] leading-3 mt-[36px]'>
        <Skeleton width='677px' height='11px' borderRadius='13px' count={1} />
      </div>
      <div className='h-[11px] leading-3 mt-[36px]'>
        <Skeleton width='677px' height='11px' borderRadius='13px' count={1} />
      </div>
      <div className='h-[11px] leading-3 mt-[36px]'>
        <Skeleton width='677px' height='11px' borderRadius='13px' count={1} />
      </div>
      <div className='h-[11px] leading-3 mt-[36px]'>
        <Skeleton width='677px' height='11px' borderRadius='13px' count={1} />
      </div>
      <div className='h-[11px] leading-3 mt-[36px]'>
        <Skeleton width='677px' height='11px' borderRadius='13px' count={1} />
      </div>
    </SkeletonTheme>
  </div>
);
